import { tokensConfig } from "@/app/providers/tokens-config";

const nativeTokens: { [key: string]: boolean } = {
    'ETH': true,
    'MATIC': true,
    'POL': true,     // Polygon native (renamed from MATIC in 2024, Para uses POL)
    'BNB': true,
    'SOL': true,
    'SOLANA': true,
    'AVAX': true,    // Avalanche native
};

export const isNativeToken = (symbol: string): boolean => {
    return nativeTokens[symbol.toUpperCase()];
};